'use client'

import { useEffect } from 'react'

import { captureTracewayException, recordTracewayBreadcrumb } from '@/lib/traceway-breadcrumbs'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    recordTracewayBreadcrumb('navigation', 'route error boundary', {
      digest: error.digest ?? null,
      message: error.message,
      name: error.name,
    })
    void captureTracewayException(error, {
      boundary: 'route-error',
      digest: error.digest ?? null,
    })
  }, [error])

  return (
    <div className="flex min-h-dvh items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(124,69,47,0.12),_transparent_40%),linear-gradient(180deg,#fbf7ef_0%,#f5ede0_100%)] px-6">
      <div className="max-w-lg rounded-[2rem] border border-[rgba(116,102,70,0.18)] bg-[#fffdf8] p-6 text-center shadow-[0_20px_60px_rgba(91,78,43,0.12)]">
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#8b5a13]">Something broke</p>
        <h1 className="mt-3 text-3xl font-semibold text-[#2f2a22]">We could not render this page.</h1>
        <p className="mt-3 text-sm leading-6 text-[#6a5c48]">
          The app hit an unexpected error. You can retry the page, or refresh the browser if the issue persists.
        </p>
        <div className="mt-6 flex items-center justify-center gap-3">
          <button
            className="rounded-full bg-[#7c452f] px-4 py-2 text-sm font-semibold text-white shadow-[0_4px_16px_rgba(124,69,47,0.25)] transition hover:bg-[#6e3c28]"
            onClick={reset}
            type="button"
          >
            Try again
          </button>
        </div>
      </div>
    </div>
  )
}

